// extracted by mini-css-extract-plugin
export default {"dashboardCon":"Dashboard_dashboardCon__DEYi7","clientsOfInterestTableCon":"Dashboard_clientsOfInterestTableCon__CDO41","allClientsTableCon":"Dashboard_allClientsTableCon__JYr2I"};